const edit = {
  Title: 'Edit Job',
  Subtitle: 'Update job details and requirements',
  Actions: {
    UpdateJob: 'Update Job',
  },
  Loading: 'Loading job data...',
};

export default edit;
